var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { getLatestStories } from "../../../actions/latestStories";
import MiniStoryCard from "../MiniStoryCard";
import Spinner from "../Spinner";
import Ad from "components/Library/Ad";
import styles from "./LatestStories.css";

var LatestStories = function (_Component) {
  _inherits(LatestStories, _Component);

  function LatestStories() {
    _classCallCheck(this, LatestStories);

    return _possibleConstructorReturn(this, (LatestStories.__proto__ || Object.getPrototypeOf(LatestStories)).apply(this, arguments));
  }

  _createClass(LatestStories, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.latestStories.results.length) {
        this.props.getLatestStories();
      }
    }
  }, {
    key: "renderPromo",
    value: function renderPromo() {
      return React.createElement(
        "div",
        { className: styles.promo },
        React.createElement(Ad, { adUnit: "sidebar", slotSize: [300, 275] })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.latestStories.results.length === 0) {
        if (this.props.latestStories.isLoading) {
          return React.createElement(Spinner, null);
        }
        return null;
      }

      var latestSorted = this.props.latestStories.results.sort(function (a, b) {
        return a.published_date > b.published_date ? -1 : a.published_date < b.published_date ? 1 : 0;
      });

      return React.createElement(
        "div",
        { className: this.props.className },
        React.createElement(
          "h2",
          { className: classNames(styles.heading, styles.hiddenLarge) },
          "Latest Stories"
        ),
        React.createElement(
          "div",
          { className: styles.root },
          React.createElement(
            "h2",
            { className: classNames(styles.heading, styles.hiddenSmall) },
            "Latest Stories"
          ),
          latestSorted.map(function (latest, i) {
            return React.createElement(
              "div",
              { key: latest.id },
              React.createElement(MiniStoryCard, { latest: latest }),
              i === 4 && _this2.renderPromo()
            );
          })
        )
      );
    }
  }]);

  return LatestStories;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    latestStories: state.latestStories
  };
};

export default connect(mapStateToProps, { getLatestStories: getLatestStories })(LatestStories);


// WEBPACK FOOTER //
// ./src/components/Library/LatestStories/LatestStories.js